import { Component, Prop, Vue, Model, Emit } from 'vue-property-decorator';
import IconStar from '@/components/IconStar.vue';
import { SurveyRatingElementOptions } from '@/models/survey-elements/rating-options';
@Component({
  components: {
    IconStar,
  },
})
export default class RatingSelectComponentMixin extends Vue {
  @Model('change', { type: [Number, Object] }) modelValue!:
    | number
    | SurveyRatingElementOptions;
  @Prop({ type: Boolean, default: true }) disabled!: boolean;

  @Emit('change')
  private onChange(value: number | SurveyRatingElementOptions) {
    return value;
  }
}
